<script>
  import { onMount } from "svelte";
  import { getNotificationsContext } from "svelte-notifications"
  import Button from "../../../components/button/Button.svelte";
  import DownloadIconButton from "../../../components/IconButtons/DownloadIconButton.svelte";
  import { downloadFile } from "../../../utils/download.js";
  import { getAutoAssemblyProjectContext } from "../../AutoAssemblyProjectContext.js";
  import S1Package from "../../../views/S1Package/S1Package.svelte";

  const {addNotification} = getNotificationsContext()
  const ctx = getAutoAssemblyProjectContext()
  const projectId = $ctx.projectId
  const planId = $ctx.planId

  async function onClickDownload() {
    const response = await fetch(`/api/auto-mps/projects/${projectId}/plans/${planId}/output`)

    downloadFile(await response.blob(), "production_output.csv")
  }

  let hasLevelingFinished = false;

  onMount(async () => {
    // when mounted, dispatch the "leveling" request to the backend, and wait for the response to be returned.
    // then show the input order graph.

    const response = await fetch(`/api/projects/${$ctx.projectId}/triggers/data/upload`, {
      method: "POST",
      body: JSON.stringify({
        schedulingParameterName: "main",
      }),
      headers: {
        "Content-Type": "application/json",
      }
    })

    if (!response.ok) {
      addNotification({
        position: "top-right",
        type: "error",
        removeAfter: 4000,
        text: `失敗しました。`
      })
    }
    await new Promise(r => setTimeout(r, 2000));
    hasLevelingFinished = true;
  })
</script>

<div class="content-root">
  {#if hasLevelingFinished}
    <div style="padding: 1rem; display: flex; justify-content: end; gap: .5rem">
      <Button>
        データをエクスポートする
      </Button>
      <DownloadIconButton onClick={onClickDownload}/>
    </div>
    <S1Package />
  {:else}
    <div style="width: 100%; height: 100%; display: grid; place-items: center">
      <div>
        Asprova Auto Assembly を使用して負荷の平準化を行っています...
      </div>
    </div>
  {/if}
</div>

<style>
  .content-root {
    height: 100%;
    background-color: white;
    padding: 1rem;
    max-width: 100%;
  }
</style>
